$(document).ready(() => {
  $('[data-coupon-book]').on('change', (event) => {
    $('[data-external-shop-coupon-book]').each(function () {
      this.value = event.target.value;
    });
  });
});
